import { z } from "zod";

import { buildApiGatewaySchemas } from "@smart/itops-constructs-basic";
import { undefinedOrEmptyObject } from "@smart/itops-utils-basic";

import { apiGateway } from "./api-gateway";
import { stashSchema } from "./shared-schemas";

export const checkLambdaSchema = {
  input: undefinedOrEmptyObject,
  output: z.object({
    hasToken: z.boolean(),
    email: z.string().optional(),
    provider: z.string().optional(),
  }),
};

export const clearLambdaSchema = {
  input: undefinedOrEmptyObject,
  output: z.literal(""),
};

export const envLambdaSchema = {
  input: undefinedOrEmptyObject,
  output: z.object({
    awsRegion: z.string(),
    smokeballClientId: z.string(),
    smokeballUserPoolId: z.string(),
  }),
};

export const recallLambdaSchema = {
  input: undefinedOrEmptyObject,
  output: z.literal(""),
};

export const stashLambdaSchema = {
  input: stashSchema,
  output: z.object({}),
};

export const apiSchemas = buildApiGatewaySchemas(apiGateway, {
  check: checkLambdaSchema,
  clear: clearLambdaSchema,
  env: envLambdaSchema,
  recall: recallLambdaSchema,
  stash: stashLambdaSchema,
});
